export const constants = {
  IPM_CONTENT_ENDPOINT: '/api/ipm-service/v1/content',
  IPM_FULLLENGTH_AD_URL:
    'https://ngapps-fit.nj.adp.com/apps/ipm/app/fulllength-ad',
  CONTENT_TYPE_JSON: 'application/json',
  IPM_LOAD_TIMEOUT_MS: 60000,
};
